module.exports = {
  'CHINESE': require('./chinese'),
  'ENGLISH': require('./english'),
  'FRENCH': require('./french'),
  'ITALIAN': require('./italian'),
  'JAPANESE': require('./japanese'),
  'SPANISH': require('./spanish')
};



//////////////////
// WEBPACK FOOTER
// ./~/bitcore-mnemonic/lib/words/index.js
// module id = 999
// module chunks = 0